// ======================================================================
// File Name       : TranslateConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as modalActions from '../../actions/ModalAction';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import { DOCUMENT_EDIT_TYPE } from '../../constants/ContentConstant';
import * as ModalIds from '../../constants/ModalIds';
import { convertLanguageName } from '../../utils/ContentUtils';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import ModalWrapper from '../modal/ModalWrapper';

class TranslateConfirmDialog extends React.Component {
  constructor() {
    super();
    this.getModalOptions = this.getModalOptions.bind(this);
    this.handleOK = this.handleOK.bind(this);
  }

  getModalOptions() {
    return {
      title: 'ファイルの変更',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        { name: 'OK', onClick: this.handleOK, variant: 'primary' },
      ],
      dialogClassName: 'translate-confirm-dialog',
    };
  }

  handleOK() {
    const { multiLanguageConfirmInfo, languageInfo } = this.props;
    const { byLanguageCode } = languageInfo;
    if (multiLanguageConfirmInfo) {
      const params = {};
      params.editType = byLanguageCode[multiLanguageConfirmInfo.languageCode]
        ? DOCUMENT_EDIT_TYPE.UPDATE
        : DOCUMENT_EDIT_TYPE.REGISTER;
      params.contentSecernId = multiLanguageConfirmInfo.contentSecernId;
      params.languageCode = multiLanguageConfirmInfo.languageCode;
      if (multiLanguageConfirmInfo.uploadFile) {
        params.uploadFile = multiLanguageConfirmInfo.uploadFile[0];
      }
      this.props.dispatch(showLoading());
      this.props.dispatch(MultiLanguageAction.editLanguageInfo(params)).then((error) => {
        this.props.dispatch(hideLoading());
        if (!error) {
          this.props.hideModal();
          this.props.dispatch(modalActions.openModal(ModalIds.TRANSLATE_COMPLETE));
        }
      });
    }
  }

  render() {
    const { multiLanguageConfirmInfo } = this.props;
    const { contentSecernId, contentName, languageCode, uploadFile } = multiLanguageConfirmInfo;

    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <div>
          以下の内容で登録します。
          <Col sm={12} className="margin-top-10">
            <Form className='form-horizontal'>
              <Form.Group className="form-info">
                <Col sm={4} className="form-label">
                  コンテンツ識別ID
                </Col>
                <Col sm={8} className="form-label">
                  {contentSecernId}
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={4} className="form-label">
                  コンテンツ名
                </Col>
                <Col sm={8} className="form-label" >
                  {contentName}
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={4} className="form-label">
                  言語
                </Col>
                <Col sm={8} className="form-label" >
                  {convertLanguageName(languageCode)}
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={4} className="form-label">
                  アップロードファイル名
                </Col>
                <Col sm={8} className="form-label" >
                  {uploadFile && uploadFile[0] && uploadFile[0].name}
                </Col>
              </Form.Group>
            </Form>
          </Col>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { multiLanguageConfirmInfo, languageInfo } = state.multiLanguage;
  return {
    ...{ multiLanguageConfirmInfo },
    ...{ languageInfo },
  };
};

export default connect(mapStateToProps)(TranslateConfirmDialog);
